if (!customElements.get('media-carousel')) {
  customElements.define(
    'media-carousel',
    class MediaCarousel extends HTMLElement {
      constructor() {
        super();
        
        this.slider = this.querySelector('.carousel-list');
        this.sliderItems = this.querySelectorAll('.carousel-list > *');
        this.imageCount = Number(this.dataset.size);
        this.dotsBar = this.querySelector('.media-dots--bar');
        this.currentPage = 1;
        this.sliderFirstItemNode = this.sliderItems[0];
        
        this.prevButton = this.querySelector('[previous-image]');
        this.nextButton = this.querySelector('[next-image]');
        this.currentIndex = 0;
        
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.currentIndex = entry.target.index;
                document.dispatchEvent(new CustomEvent('custom:carousel:index', { detail: entry.target.index }));
              }
            });
          },
          {
            threshold: 0.51,
          },
        );
    
        this.sliderItems.forEach((sliderItem, index) => {
          sliderItem.index = index;
          this.observer.observe(sliderItem);
        });
    
        if (this.dataset.desktopTouch) {
          this.initDesktopTouch();
        }

        const shownPeek = localStorage.getItem('shownPeek')
    
        if(this.dataset.first === "true" && !shownPeek) {
          this.observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.initPeek();
                }
              });
            },
            {
              threshold: 1,
            },
          );
      
          this.observer.observe(this);
        }
        
        
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

        this.slider.addEventListener('scroll', this.update.bind(this));
      }

      update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        const percentageComplete = (this.currentPage / this.imageCount) * 100
        this.dotsBar.style.width = `${percentageComplete}%`
        
        if (this.currentPage != previousPage) {
          this.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1],
              },
            })
          );
        }
      }

      onButtonClick(event) {
    
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (event.currentTarget.name === 'next') {
          this.currentPage = this.currentPage + 1
        } else {
          this.currentPage = this.currentPage - 1
        }
        
        if (isFirstSlide && event.currentTarget.name === 'previous') {
          
          this.slideScrollPosition =
            this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
            this.currentPage = this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
          
          this.slideScrollPosition = 0;
          this.currentPage = 1;
        } else {
          const step = event.currentTarget.dataset.step || 1;
          this.slideScrollPosition =
            event.currentTarget.name === 'next'
              ? this.slider.scrollLeft + step * this.sliderItemOffset
              : this.slider.scrollLeft - step * this.sliderItemOffset;
        }
        
        this.setSlidePosition(this.slideScrollPosition);
        
      }

      setSlidePosition(position) {
        if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
        this.setPositionTimeout = setTimeout(() => {
          this.slider.scrollTo({
            left: position,
          });
          setTimeout(() => {
            
            this.update();
          }, 100);
        }, 66);
      }
    
    
      disconnectedCallback() {
        this.observer.disconnect();
      }
    
      initPeek() {
        let leftOffset = this.slider.getBoundingClientRect().width / 2;
        this.slider.classList.add('snap-none');
        requestAnimationFrame(() => {
          this.sliderItems.forEach((sliderItem) => sliderItem.classList.add('pointer-events-none', 'select-none'));
          this.slider.scrollLeft = leftOffset;

          setTimeout(() => {
            this.slider.scrollLeft = 0;
            setTimeout(() => {
              localStorage.setItem('shownPeak', 'true')
              this.slider.classList.remove('snap-none');
              this.sliderItems.forEach((sliderItem) => sliderItem.classList.remove('pointer-events-none', 'select-none'));
            }, 250);
          }, 250);
        });
      }
    
      initDesktopTouch() {
        if (window.innerWidth <= 767) return;
        this.sliderItems.forEach((sliderItem) => sliderItem.classList.add('pointer-events-none', 'select-none'));
    
        let isDrag = false;
        let timeout;
        const dragStart = (ev) => {
          console.log('dragStart');
          isDrag = true;
          this.slider.classList.add('snap-none');
          if (timeout) clearTimeout(timeout);
        };
        const dragEnd = () => {
          console.log('dragEnd');
          if (!isDrag) return;
          isDrag = false;
          this.sliderItems[this.currentIndex].scrollIntoView({ behavior: 'smooth' });
          timeout = setTimeout(() => {
            this.slider.classList.remove('snap-none');
          }, 700);
        };
        const drag = (event) => {
          if (!isDrag) return;
          this.slider.scrollLeft -= event.movementX * 1.6;
        };
    
        this.slider.addEventListener('pointerdown', dragStart);
        this.slider.addEventListener('pointerup', dragEnd);
        this.slider.addEventListener('pointerleave', dragEnd);
        this.slider.addEventListener('pointermove', drag);
      }

    }
  );
}
